import { isFunction } from 'coreutils-js';
import API from 'libs/api';
import { createAuthInstance } from 'libs/request';
//@ts-ignore
import config from 'config/index';
import { action } from 'mobx';

export interface ICreatePerm {
  name: string,
  description?: string,
  applicationId: string,
  code: string,
  groupId: string,
}

export interface IUpdatePerm {
  name: string,
  description?: string,
  code: string,
  groupId: string,
}

class PermissionAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(`${config.api.auth}permission/`, createAuthInstance);
  }

  createPermission = (data: ICreatePerm) => {
    return this.instance.post('/', data);
  }

  updatePermission = (id: string, data: IUpdatePerm) => {
    return this.instance.put(`/${id}`, data)
  }

  deletePermission = (id: string) => {
    return this.instance.delete(`/${id}`)
  }

  getPermission = (applicationId) => {
    return this.instance.get(`/`, { params: { applicationId } });
  }


}

export default PermissionAPI;
